var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSubscription(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    className: "svg-path1",
    fillOpacity: 0.5,
    d: "M0 0h50v50H0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "svg-path2",
    fillOpacity: 0.8,
    d: "M0 0h6v50H0z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "svg-path3",
    fillOpacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.4 13.6H17.6v22.8h14.8V13.6zM31 15v20H19V15h12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.7 16.3h-6.4v17.4h6.4V16.3zm-1.4 1.4v14.6h-3.6V17.7h3.6zM18.7 16.3h-6.4v17.4h6.4V16.3zm-1.4 1.4v14.6h-3.6V17.7h3.6zM25 19a3 3 0 1 1 0 6 3 3 0 0 1 0-6zm0 1.4a1.6 1.6 0 1 0 0 3.2 1.6 1.6 0 0 0 0-3.2zM29.2 27.3v1.4h-8.4v-1.4zM29.2 30.3v1.4h-8.4v-1.4z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubscription);
export default __webpack_public_path__ + "static/media/subscription.3bbdf8b8d26a446d890d445f3a5a9d1f.svg";
export { ForwardRef as ReactComponent };